import React from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Collapse, Tooltip } from 'reactstrap';
import MarketImage from '../Common/MarketImage';
import RentCycleConstants from '../../constants/RentCycleConstants';
import { sectorDetails } from '../../helpers/Utils';
import goback from '../../images/left-arrow-head.svg';
import infoIcon from '../../images/info-icon.svg';
import expandIcon from '../../images/expand-arrow.svg';
import collapseIcon from '../../images/collapse-arrow.svg';
import { clearComparisonMarketDetails, clearCompareInfoMobile, fetchMarketDetails,fetchPeriods } from "../../actions";
import { withRouter } from 'react-router-dom';
import MetricConverter from '../Common/MetricConverter';
import { getParams } from '../../helpers/Utils';


const subMarket = [{ key: "submarket1", desc: "submarket1Desc" }, { key: "submarket2", desc: "submarket2Desc" }, { key: "submarket3", desc: "submarket3Desc" }];

export class MarketComparisonMobile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showOfficeCompareData: true,
            showCompareKeySubmarkets: true,
            showCompareRentCyclePositions: true,
            toolTipIndex: false,
            toolTipCompareIndex: false,
            isOpenSourceLeft: false,
            isOpenSourceRight: false
        }
    }

    goBack = () => {
        let { history, clearComparisonMarketDetails } = this.props;

        clearComparisonMarketDetails();
        history.goBack();
    }
    
    toggleOfficeCompareData = () => {
        this.setState({ showOfficeCompareData: !this.state.showOfficeCompareData })
    }

    toggleCompareKeySubmarkets = () => {
        this.setState({ showCompareKeySubmarkets: !this.state.showCompareKeySubmarkets })
    }

    toggleCompareRentCyclePositions = () => {
        this.setState({ showCompareRentCyclePositions: !this.state.showCompareRentCyclePositions })
    }

    getCurrentPositon (){

        let latestQuarter = (this.props.periodList[this.props.periodList.length -1 ])
        let filteredLists=[];
        if(this.props.marketquarters)
        {
         filteredLists = this.props.marketquarters.filter(function (x) {
          return x.period === latestQuarter;
        });
    }
        if(this.state.closeButtonVisible){
          filteredLists = [this.props.marketCompareQuarters[this.props.marketCompareQuarters.length-1]];
        }
  
      return  (filteredLists[0] ? filteredLists[0].position : 0);
  
    }

    displaySectorTextWithColor(position)
    {

        if(!position){
            position = parseInt(this.getCurrentPositon());
        } 
        else{
            position = parseInt(position);
        }
            const {sectorColor, sectorText} = sectorDetails(position);
            return <span>{sectorText}</span>
    }

    handleInfoClicked = (index) => {
        this.setState((state) => ({
            toolTipIndex: state.toolTipIndex === index ? null : index
        }))
    }

    handleCompareInfoClicked = (index) => {
        this.setState((state) => ({
            toolTipCompareIndex: state.toolTipCompareIndex === index ? null : index
        }))
    }



  renderArea = (list, key) => {
    let areaOn ='';
    list.forEach(element => {
      if ((element.market) === this.props.marketselected.trim()) {
        if (element.market.length > 0) {
          areaOn= element[key];
      }

      }
    });
    return areaOn;   
  }

  renderAreaCompare = (list, key) => {
    let areaOn ='';
    list.forEach(element => {
      if ((element.market) === this.props.compareMarketSelected.trim()) {
        if (element.market.length > 0) {
          areaOn= element[key];
      }

      }
    });
    return areaOn;   
  }
  renderSource = (value) => {
    return  (value ? "Source: " + value : "Source: not provided");
  }

  toggleSourceLeft = () => {
    this.setState({isOpenSourceLeft: !this.state.isOpenSourceLeft});
  }
  toggleSourceRight = () => {
    this.setState({isOpenSourceRight: !this.state.isOpenSourceRight});
  };

  componentDidMount()
  {
   
   if(this.props.periodList.length <=0)
   {
     this.props.fetchPeriods();
   }

   const selectedMarket = getParams(window.location, 'market');
   if(selectedMarket !== '')
   {    
        if(selectedMarket.trim() !== this.props.marketselected.trim())
        {
          this.props.fetchMarketDetails('FETCH_MARKET_DETAILS' , selectedMarket);
        }
   }

   const compareMarket = getParams(window.location, 'comparemarket');
   if(compareMarket !== '')
   {    
        if(compareMarket.trim() !== this.props.compareMarketSelected.trim())
        {
           this.props.fetchMarketDetails('FETCH_COMPARE_MARKET_DETAILS' , compareMarket);
        }
   }

  }

    render() {
        const { periodList, marketcomparequarters, marketQuarters, compareMarketSelected, marketselected } = this.props;
        const latestQuarter = periodList[periodList.length -1 ];

        return (
            <Container className="main-comparison-container">
                <Row className="mobile-comparison-main-header">
                    <div className="title" style={{paddingLeft: "20px", display: "flex", alignItems: "center"}}>
                        <img className="go-back-mobile" alt="back" src={'#{rentrackerappimages}#' +'/left-arrow-head.svg'} onClick={this.goBack}/>
                        <span className="market-detail-mobile-header-text"> {RentCycleConstants.COMPARISON_HEADER_TEXT} </span>
                    </div>
                </Row>
                <Row>
                    <Col xs={6} className="market-comparison-img-col">
                        <MarketImage devicetype="mobile" classes ="market-comparison-img-mobile right-border" rightPanel={false} comparisonVisible={false} />
                    </Col>
                    <Col xs={6} className="market-comparison-img-col"> <MarketImage devicetype="mobile" classes ="market-comparison-img-mobile" rightPanel={true} comparisonVisible={true}  /></Col>
                </Row>
                <Row className="market-comparison-row">
                    <Col xs={6} className="detail-panel-title-text-mobile right-border">{marketselected}</Col>
                    <Col xs={6} className="detail-panel-title-text-mobile"> {compareMarketSelected}</Col>
                </Row>
                <Row className="sub-child-header">
                    <Col>
                        {RentCycleConstants.POPULATION}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} className="compare-data-value right-border"> {marketQuarters.map(x => x.population)[0]} M
                        <img href="#" alt="info-icon" id={`sourcetooltipLeft`} src={'#{rentrackerappimages}#' +'/info-icon.svg'} className="ic_info_outline_24px-mobile-comparison" />
                        <Tooltip trigger="legacy" style={{ textDecoration: "bold", fontFamily: "Calibre", textAlign: "left", color: "white", backgroundColor: "#012A2D" }} placement="bottom-end" 
                        isOpen={this.state.isOpenSourceLeft} target="sourcetooltipLeft" toggle={this.toggleSourceLeft}>
                            {marketQuarters.map(x => this.renderSource(x.populationSource))[0]}
                        </Tooltip>
                    </Col>
                    <Col xs={6} className="compare-data-value"> {marketcomparequarters.map(x => x.population)[0]} M
                    <img href="#" alt="info-icon" id={`sourcetooltipRight`} src={'#{rentrackerappimages}#' +'/info-icon.svg'} className="ic_info_outline_24px-mobile-comparison" />
                        <Tooltip trigger="legacy" style={{ textDecoration: "bold", fontFamily: "Calibre", textAlign: "left", color: "white", backgroundColor: "#012A2D" }} placement="bottom-end" 
                        isOpen={this.state.isOpenSourceRight} target="sourcetooltipRight" toggle={this.toggleSourceRight}>
                            {marketcomparequarters.map(x => this.renderSource(x.populationSource))[0]}
                        </Tooltip>
                    </Col>
                </Row>
                <Row className="sub-child-header">
                    <Col>
                        {RentCycleConstants.OFFICE_MARKET_SIZE}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} className="compare-data-value right-border"> <MetricConverter officerent={marketQuarters.map(x => x.overallOfficeMarketSize)[0]}/></Col>
                    <Col xs={6} className="compare-data-value"> <MetricConverter officerent={marketcomparequarters.map(x => x.overallOfficeMarketSize)[0]}/></Col>
                </Row>
                <Row className="sub-child-header">
                    <Col>
                        {RentCycleConstants.LEARN_MORE_ABOUT_CBRE}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} className="compare-data-value right-border"><a  target="_blank" href={marketQuarters.map(x => x.url)[0]} rel="noreferrer noopener" className="learn-about-market-link">{marketselected}</a></Col>
                    <Col xs={6} className="compare-data-value"><a target="_blank" href={marketcomparequarters.map(x => x.url)[0]} rel="noreferrer noopener" className="learn-about-market-link">{compareMarketSelected}</a></Col>
                </Row>
                <Row className="sub-child-header">
                    <Col >
                        {/* <div className="accordian-header-text"> */}
                            {RentCycleConstants.KEY_SUBMARKETS}
                        {/* </div> */}
                        {/* <div className="accordian-toggle">
                            <img className="accordian-icon" alt="accordian" src={this.state.showCompareKeySubmarkets ? collapseIcon : expandIcon}/>
                        </div> */}
                    </Col>
                </Row>
                {/* <Collapse isOpen={this.state.showCompareKeySubmarkets}> */}
                <Row style={{backgroundColor:'#F5F7F7'}}>
                    <Col xs={6} style={{ padding: 0 }} >
                        {marketQuarters && marketQuarters[0] && subMarket.map((element, index) => {
                            if (marketQuarters[0][`${element.key}`]) {
                                return (<div className="submarket-comparison-mobile bottom-border right-border" style={index === 2 ? { borderBottom: "none" } : {}} key={index}>
                                    <span>{marketQuarters[0][`${element.key}`]}</span>
                                    <img href="#" alt="info-icon" id={`mobilesubmarket${index}tooltip`} src={'#{rentrackerappimages}#' + '/info-icon.svg'} className="ic_info_outline_24px-mobile-comparison" />
                                    <Tooltip trigger="legacy" style={{ textDecoration: "bold", fontFamily: "Calibre", textAlign: "left", color: "white", backgroundColor: "#012A2D" }} placement="bottom-end" isOpen={this.state.toolTipIndex === index} toggle={() => this.handleInfoClicked(index)} target={`mobilesubmarket${index}tooltip`} >
                                        {marketQuarters[0][`${element.desc}`]}
                                    </Tooltip>
                                </div>)
                            }
                            else {
                                return (<div key={index} style={{
                                    "borderBottom": index === 2 ? "none" : "2px solid #CAD1D3",
                                    "borderRight": "2px solid #CAD1D3",
                                    "height": "69px"
                                }}/>)
                            }
                        }
                        )}
                    </Col>
                    <Col xs={6} style={{ padding: 0 }}>
                        {marketcomparequarters && marketcomparequarters[0] && subMarket.map((element, index) => {
                            if (marketcomparequarters[0][`${element.key}`]) {
                            return (
                                <div className="submarket-comparison-mobile bottom-border" style={index === 2 ? { borderBottom: "none" } : {}} key={index}>
                                    <span>{marketcomparequarters[0][`${element.key}`]}</span>
                                    <img href="#" alt="" id={`mobilecomparesubmarket${index}tooltip`} src={'#{rentrackerappimages}#' +'/info-icon.svg'} className="ic_info_outline_24px-mobile-comparison" />
                                    <Tooltip trigger="legacy" style={{ textDecoration: "bold", fontFamily: "Calibre", textAlign: "left", color: "white", backgroundColor: "#012A2D" }} placement="bottom-end" isOpen={this.state.toolTipCompareIndex === index} toggle={() => this.handleCompareInfoClicked(index)} target={`mobilecomparesubmarket${index}tooltip`} >
                                        {marketcomparequarters[0][`${element.desc}`]}
                                    </Tooltip>
                                </div>
                            )
                            }
                            else {
                                return (<div key={index} style={{
                                    "borderBottom": index === 2 ? "none" : "2px solid #CAD1D3",
                                    "height": "69px"
                                }}/>)
                            }
                        })}
                    </Col>
                </Row>
                {/* </Collapse> */}
                <Row className="sub-child-header-alternate">
                    <Col >
                        {/* <div className="accordian-header-text"> */}
                            {latestQuarter} {RentCycleConstants.OFFICE_DATA}
                        {/* </div> */}
                        {/* <div className="accordian-toggle">
                            <img className="accordian-icon" alt="accordian" src={this.state.showOfficeCompareData ? collapseIcon : expandIcon} />
                        </div> */}
                    </Col>
                </Row>
                {/* <Collapse isOpen={this.state.showOfficeCompareData}> */}
                    <Row className="sub-child-header">
                        <Col>
                            {RentCycleConstants.RENT_CYCLE_POSITION}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} className="compare-data-value right-border">{this.displaySectorTextWithColor(marketQuarters.length > 0 ? marketQuarters[4].position: 0)}</Col>
                        <Col xs={6} className="compare-data-value">{this.displaySectorTextWithColor(marketcomparequarters.length >0 ? marketcomparequarters[4].position: 0)}</Col>
                    </Row>

                    <Row className="sub-child-header">
                        <Col>
                            {RentCycleConstants.OVERALL_VACANCY}
                        </Col>
                    </Row>                            
                    <Row className="sub-child-header">
                        <Col>
                            {RentCycleConstants.OVERALL_RENT_CHANGE_YOY}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} className="compare-data-value right-border">{marketQuarters.map(x => x.overallRentChange)[0]}%</Col>
                        <Col xs={6} className="compare-data-value">{marketcomparequarters.map(x => x.overallRentChange)[0]}%</Col>
                    </Row>
                {/* </Collapse> */}
                <Row className="sub-child-header">
                    <Col >
                        {/* <div className="accordian-header-text"> */}
                            {RentCycleConstants.HISTORICAL_RENT_CYCLE_POSITIONS}
                        {/* </div> */}
                        {/* <div className="accordian-toggle">
                            <img className="accordian-icon" alt="accordian" src={this.state.showCompareRentCyclePositions ? collapseIcon : expandIcon} />
                        </div> */}
                    </Col>
                </Row>
                {/* <Collapse isOpen={this.state.showCompareRentCyclePositions}> */}
                    {marketQuarters && marketcomparequarters && marketQuarters.map((element,index)=> (
                        <Row className="bottom-border" key={index} style={{backgroundColor:'#F5F7F7'}}>
                            <Col xs={6} className="compare-rent-cycle-left-col">{this.displaySectorTextWithColor(marketQuarters[marketQuarters.length-index-1].position)}</Col>
                            <div className="comparison-quarter-value">
                                <div>{periodList[periodList.length-index-1]}</div>
                            </div>
                            <Col xs={6} className="compare-rent-cycle-right-col">{this.displaySectorTextWithColor(marketcomparequarters.length >0 ? marketcomparequarters[marketcomparequarters.length-index-1].position: 0)}</Col>
                        </Row>
                    ))
                    }
                {/* </Collapse> */}
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        marketQuarters: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].marketDetails : [],
        marketcomparequarters: state.comparisonMarkets.comparisonMarkets[1] ? state.comparisonMarkets.comparisonMarkets[1].marketDetails : [],
        marketselected: state.comparisonMarkets.comparisonMarkets[0] ? state.comparisonMarkets.comparisonMarkets[0].market : '',
        compareMarketSelected: state.comparisonMarkets.comparisonMarkets[1] ? state.comparisonMarkets.comparisonMarkets[1].market : '',
        periodList: state.periodList
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        clearComparisonMarketDetails: () => {
            dispatch(clearComparisonMarketDetails())
        },
        fetchMarketDetails: (actionType, selectedMarket) => {
     
            dispatch(fetchMarketDetails(actionType, selectedMarket))
          },
        clearCompareInfoMobile: (clearText, clearArray) => {
            dispatch(clearCompareInfoMobile(clearText, clearArray))
        },
        fetchPeriods: () => {
          dispatch(fetchPeriods());
         }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketComparisonMobile))
